import { render } from "./RoomForm.vue?vue&type=template&id=3a4f543c&scoped=true"
import script from "./RoomForm.vue?vue&type=script&lang=js"
export * from "./RoomForm.vue?vue&type=script&lang=js"

import "./RoomForm.vue?vue&type=style&index=0&id=3a4f543c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4f543c"]])

export default __exports__